// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showSuccess, showError } from "../actions/globalActions";
import cookie from "../utils/cookie";
import sanitizeModelPayload from '@staty/shared/utils/sanitizeModelPayload';
import getApiErrorMessage from '../utils/getApiErrorMessage';

const baseUrl = `${process.env.API_URL}/api/v1`;
// axios.defaults.headers.common["Authorization"] = `Bearer ${cookie.get("clerk_token")}`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useTournamentStore = create(immer((set) => ({
  tournaments: [],
  leagues: [],

  // Asynchronous actions
  getTournamentById: async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/tournaments/${id}?include=config.paymentProduct`);
      set((state) => {
        const index = _.findIndex(state.tournaments, { _id: id });
        if (index >= 0) {
          state.tournaments[index] = data.result;
        } else {
          state.tournaments.push(data.result);
        }
      });
    } catch (error) {
      console.error("Error in getTournamentById:", error);
    }
  },

  // ... Continue with other actions ...

  updateTournament: (getToken) => {
    return async (tournament, cb) => {
      try {
        const token = await getToken();
        const payload = sanitizeModelPayload({ model: 'tournament' }, tournament);
        const { data, status, error } = await axios.put(`${baseUrl}/tournaments/${tournament._id}`, payload, createAuthHeader(token));
        console.log("updateTournament data: ", data, status, error);
        if (error) {
          showError("Error", "Update Error");
          return;
        } else {
          showSuccess("Success", "Successfully Updated");
          set((state) => {
            const index = state.tournaments.findIndex(d => d._id === tournament._id);
            if (index !== -1) {
              state.tournaments[index] = data.result;
            }
          });
          cb && cb(data.result);
        }
      } catch (error) {
        if (!error.permissionToastShown) {
          showError("Error", getApiErrorMessage(error, "Update Error"));
        }
        console.error("Error in updateTournament:", error);
      }
    }
  },

  patchTournament: (getToken) => {
    return async (tournament) => {
      try {
        const token = await getToken();
        const payload = sanitizeModelPayload({ model: 'tournament' }, tournament);
        const { data, status, error } = await axios.patch(`${baseUrl}/tournaments/${tournament._id}`, payload, createAuthHeader(token));
        console.log("patchTournament data: ", data, status, error);
        if (error) {
          showError("Error", "Update Error");
          return;
        } else {
          showSuccess("Success", "Successfully Updated");
          set((state) => {
            const index = state.tournaments.findIndex(d => d._id === tournament._id);
            if (index !== -1) {
              state.tournaments[index] = data.result;
            }
          });
        }
      } catch (error) {
        if (!error.permissionToastShown) {
          showError("Error", getApiErrorMessage(error, "Update Error"));
        }
        console.error("Error in patchTournament:", error);
      }
    }
  },

  getTournamentsByLeagueName: async ({ leagueName, include = 'paymentProduct' }) => {
    try {
      const { data } = await axios.get(`${baseUrl}/tournaments/organizationName/${leagueName}?include=${include}`);
      set((state) => {
        // state.tournaments = data.result;
        // state.tournaments = _.map(_.uniqBy(data.result, "season._id"), ({ season }) => season);
        state.tournaments = _.unionBy(data.result, state.tournaments, '_id');
      });
    } catch (error) {
      console.error("Error in getTournamentsByLeagueName:", error);
    }
  },

  addTournament: (getToken) => {
    return async (tournament) => {
      const token = await getToken();
      const { data } = await axios.post(`${baseUrl}/tournaments`, tournament, createAuthHeader(token));
      set((state) => {
        state.tournaments.push(data.result);
      });
    }
  },

  cloneTournament: (getToken) => {
    return async (
      id: string,
      name: string,
      cloneChildren: boolean = true,
      cloneRegistration: boolean = false,
      cb?: Function
    ) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(
          `${baseUrl}/tournaments/d/${id}/clone`,
          { name, cloneChildren, cloneRegistration },
          createAuthHeader(token)
        );
        const { error, result } = data || {};
        if (error) {
          showError('Error', error);
          return { error };
        }
        showSuccess('Success', 'Successfully Cloned!');
        set((state) => {
          state.tournaments.push(result);
        });
        cb && cb(result);
        return { result };
      } catch (error) {
        showError('Error', 'Clone Error');
        console.error('Error in cloneTournament:', error);
        return { error: 'Error cloning tournament' };
      }
    };
  },

  deleteTournament: (getToken) => {
    return async (tournamentId, token) => {
      try {
        const token = await getToken();
        const { data }  = await axios.delete(`${baseUrl}/tournaments/${tournamentId}`, createAuthHeader(token), {});
        console.log('deleteTournament data: ', data, data.result);
        if (data.result) {
          showSuccess("Success", "Successfully Removed");
          set((state) => {
            state.tournaments = state.tournaments.filter((d) => d._id !== tournamentId);
          });
        } else {
          showError("Error", "Delete Error");
          return { error: "Delete Error" };
        }

      } catch (error) {
        showError("Error", "Delete Error");
        console.error("Error in deleteTournament:", error);
        return { error: "Delete Error" };
      }
    }
  },

})));

export default useTournamentStore;